import React, { useEffect, useState } from 'react';
import SystemIcon from '../../components/ShortStatus/SystemIcon';
import { connect } from 'react-redux';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button, TextField } from '@material-ui/core';
import ErrorText from '../../components/ErrorComponent/ErrorText';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import { Account, ISystem } from '../../helpers/interfaces';
import SweetAlert from 'react-bootstrap-sweetalert';
import UnbindFromSystem from '../../components/UnbindFromSystem/UnbindFromSystem';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import { detachAccountFromSystemByID } from '../../stores/actions/accountActions';
import Loading from '../../components/Loading/Loading';

const headerTextColor = '#3C4858';

interface UnbindUserFromSystemProps {
	accounts: Account[];
	accountID: number;
	userName: string;
	visibleSystems: ISystem[];
	mobileView: boolean;
	detachConfirmed: boolean;
	lastSystem: boolean;
	isUserDetachedFromSystem: boolean;
	detachAccountFromSystemByID: (accountId: number, systemId: number) => void;
	handleIsUserDetachedFromSystem: () => void;
}

const UnbindUserFromSystem = ({ 
	accountID,
	userName,
	visibleSystems,
	mobileView,
	detachConfirmed,
	lastSystem,
	detachAccountFromSystemByID,
	handleIsUserDetachedFromSystem,
}: UnbindUserFromSystemProps) => {
	const [alert, setAlert] = useState(null);
	const [pickedSystemName, setPickedSystemName] = useState<string>(null);
	const [pickedSystemId, setPickedSystemId] = useState<number>(null);
	const [visibleSystemsNames, setVisibleSystemsNames] = useState<string[]>([]);

	useEffect(() => {
		const visibleSystemsLabels = visibleSystems?.map((sys) => sys.name);
		setVisibleSystemsNames(visibleSystemsLabels);
		setPickedSystemName(null);
	}, [visibleSystems, detachConfirmed]);

	const hidePopup = () => {
		setAlert(null);
	};
	const handlePickSystem = (event, pickedSystemName): void => {
		setPickedSystemName(pickedSystemName);
		const currentSystemId = visibleSystems.filter(({ name }) => name === pickedSystemName)[0]?.ID;
		setPickedSystemId(currentSystemId);
	};

	const showUnbindFromSystemConfirmation = () => {
		setAlert(
			<SweetAlert
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={hidePopup}
				onCancel={hidePopup}
				title={''}
				key='unbind-user-sweet-alert'
			>
				<UnbindFromSystem
					systemName={pickedSystemName}
					hidePopup={hidePopup}
					accountID={accountID}
					accountName={userName}
					systemID={pickedSystemId}
					detachAccountFromSystemByID={detachAccountFromSystemByID}
					handleIsUserDetachedFromSystem={handleIsUserDetachedFromSystem}
					mobileView={mobileView}
					lastSystem={lastSystem}
				/>
			</SweetAlert>
		);
	};

	try {
		return (
			<ErrorComponent message='unbind use form crashed' Children>
				{alert}
				<GridItem xs={12}>
					<Card className='unbindFromSystem'>
						{visibleSystems !== undefined ? (
							<>
								<CardHeader color='info' icon>
									<CardIcon color='info'>
										<SystemIcon />
									</CardIcon>
									<h4 style={{ color: headerTextColor }}>
										Unbind <span style={{ fontWeight: 500 }}>{userName}</span> from the system
									</h4>
								</CardHeader>
								<CardBody>
									<Autocomplete
										options={visibleSystemsNames ? visibleSystemsNames : []}
										getOptionLabel={(system) => system}
										id='system-name'
										value={pickedSystemName}
										onChange={(event, newValue) => handlePickSystem(event, newValue)}
										renderInput={(systems) => <TextField {...systems} label='System' margin='normal' />}
									/>
									<Button
										disabled={!pickedSystemName}
										variant='contained'
										style={{
											backgroundColor: !pickedSystemName ? 'rgba(0,0,0,0.12)' : '#f55145',
											color: !pickedSystemName ? 'rgba(0,0,0,0.26)' : '#ffffff',
											transition: '0.2s',
											marginTop: '20px',
										}}
										onClick={showUnbindFromSystemConfirmation}
									>
										UNBIND
									</Button>
								</CardBody>
							</>
						) : (
							<div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
								<Loading transform={0.85} height={90} width={70} color='gray' />
							</div>
						)}
					</Card>
				</GridItem>
			</ErrorComponent>
		);
	} catch (error) {
		return (
			<GridItem xs={12}>
				<Card className='unbindFromSystem'>
					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<SystemIcon />
						</CardIcon>
					</CardHeader>
					<CardBody>
						<ErrorText message='Unbind from system form crashed' />
					</CardBody>
				</Card>
			</GridItem>
		);
	}
};

const mapStateToProps = (state) => ({
	mobileView: state.dashboard.mobileView,
	detachConfirmed: state.account.detachConfirmed,
});
const actions = {
	detachAccountFromSystemByID,
};

export default connect(mapStateToProps, actions)(UnbindUserFromSystem);
